import React from "react";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Text,
} from "@chakra-ui/react";
import { ConditionGroup } from "stores/data/insightAlerts/insightAlertModel";
import { ConditionBuilder } from "components/ConditionBuilder";
import { IEnvironmentalVariable } from "stores/data/oceanWeatherIntelligences/oceanWeatherIntelligenceModel";
import { Cloud } from "lucide-react";

interface AlertEditConditionProps {
  t: (key: string) => string;
  conditionGroups: ConditionGroup[] | null;
  environmentalVariables: IEnvironmentalVariable[];
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  errors?: any;
}

export const AlertEditCondition: React.FC<AlertEditConditionProps> = ({
  t,
  conditionGroups,
  environmentalVariables,
  setFieldValue,
  errors,
}) => {
  if (!conditionGroups) return null;
  return (
    <Accordion
      color="black"
      bg="white"
      mb={4}
      py={2}
      borderWidth={"1px"}
      borderColor={"gray.200"}
      borderRadius={"md"}
      allowToggle
    >
      <AccordionItem border={0}>
        <AccordionButton
          _focus={{
            border: 0,
          }}
          _hover={{
            backgroundColor: "none",
          }}
        >
          <Flex flex={1} gap="12px">
            <Cloud color="#086AA9" size="20px" />
            <Text fontWeight="500" color="#086AA9">
              {t("alertConditions")}
            </Text>
          </Flex>
          <AccordionIcon color="#086AA9" />
        </AccordionButton>
        <AccordionPanel pt={5} px={4}>
          <Box bg="#F4F4F5" padding="16px" borderRadius={8}>
            <ConditionBuilder
              conditionGroups={conditionGroups}
              environmentalVariables={environmentalVariables}
              setFieldValue={setFieldValue}
              t={t}
              errors={errors}
            />
          </Box>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
};
